module.exports = __webpack_public_path__ + "static/media/mk.12c1fffa.svg";